import React, { useEffect } from "react";
import { CAR_ABOUT_STEP, CAR_FIND_STEP, CAR_PRICE_STEP } from ".";
import { INVALID_OBJECT, PATH } from "./carConstants";

import { Icons } from "@storebrand-digital/insurance-definitions";
import { ActiveStep } from "Components/ActiveStep";
import { useExistingProductState } from "Components/Features/CheckPrice";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { BackendProductInfo } from "Features/CheckPrice/Products/productConstants";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { setCheckPriceProducts } from "Store/analytics/analyticsSlice";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { CarPriceRequestInfo } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Car";
import { sendPriceCalculationRequestStart } from "Store/priceCalculation/priceCalculationSlice";
import { useDispatch } from "react-redux";
import { Route } from "react-router";
import { InvalidInsuranceObject } from "./InvalidInsuranceObject";
import { CarProductDetails } from "./ProductDetails/CarProductDetails";
import { CarProductIntro } from "./ProductIntro/CarProductIntro";
import { CarProductPrice } from "./ProductPrice/CarProductPrice";
import { CAR_STEPS } from "./carSteps";
import { useCarStartStep } from "./catCheckPriceHooks";

interface Props {
  numberOfProductsInCart: number;
}

export const CarCheckPrice = ({
  numberOfProductsInCart,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const { getText } = useTexts();
  const startStepId = useCarStartStep();
  useExistingProductState(INSURANCE_NAME_VALUE.CAR);

  useEffect(() => {
    dispatch(setCheckPriceProducts([INSURANCE_NAME_VALUE.CAR]));
  }, []);

  const updatePriceCalculations = (
    payload: CarPriceRequestInfo,
    stepForwardOnSuccess = true,
  ): void => {
    dispatch(
      sendPriceCalculationRequestStart({
        requestInfo: payload,
        stepForwardOnSuccess,
        productPriceUrl: BackendProductInfo.CAR.priceReqUrl,
        clearOldPriceCalculations: true,
        numberOfProductsInCart: numberOfProductsInCart,
      }),
    );
  };

  return (
    <ProductTile
      title={getText("mainheading.car")}
      productName={getText("insuranceproduct.car.name")}
      productBackendName={ProductBackendName.CAR}
      productPath={PATH}
      productSteps={CAR_STEPS}
      startProductStepId={startStepId}
      iconName={Icons.CAR}
    >
      <Route
        exact
        path={`${PATH}/${CAR_FIND_STEP.id}`}
        render={() => (
          <ActiveStep>
            <CarProductIntro updatePriceRequest={updatePriceCalculations} />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PATH}/${CAR_ABOUT_STEP.id}`}
        render={() => (
          <ActiveStep>
            <CarProductDetails updatePriceRequest={updatePriceCalculations} />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PATH}/${CAR_PRICE_STEP.id}`}
        render={() => (
          <ActiveStep>
            <CarProductPrice updatePriceRequest={updatePriceCalculations} />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={INVALID_OBJECT}
        render={() => <InvalidInsuranceObject />}
      />
    </ProductTile>
  );
};
